/**
 * Se o onboarding (ou "Complete seu perfil") abriu nesta sessão. A avaliação espera a próxima
 * visita para não aparecer por cima da janela "Sua primeira busca".
 */
import { create } from 'zustand';

interface OnboardingState {
  shown: boolean;
  markShown: () => void;
}

export const useOnboardingStore = create<OnboardingState>((set) => ({
  shown: false,
  markShown: () => set({ shown: true }),
}));
